var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWnHomecomingNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.75C4.30109 3.75 4.11032 3.82902 3.96967 3.96967C3.82902 4.11032 3.75 4.30109 3.75 4.5V15C3.75 15.1989 3.82902 15.3897 3.96967 15.5303C4.11032 15.671 4.30109 15.75 4.5 15.75H13.5C13.6989 15.75 13.8897 15.671 14.0303 15.5303C14.171 15.3897 14.25 15.1989 14.25 15V4.5C14.25 4.30109 14.171 4.11032 14.0303 3.96967C13.8897 3.82902 13.6989 3.75 13.5 3.75H12C11.5858 3.75 11.25 3.41421 11.25 3C11.25 2.58579 11.5858 2.25 12 2.25H13.5C14.0967 2.25 14.669 2.48705 15.091 2.90901C15.5129 3.33097 15.75 3.90326 15.75 4.5V15C15.75 15.5967 15.5129 16.169 15.091 16.591C14.669 17.0129 14.0967 17.25 13.5 17.25H4.5C3.90326 17.25 3.33097 17.0129 2.90901 16.591C2.48705 16.169 2.25 15.5967 2.25 15V4.5C2.25 3.90326 2.48705 3.33097 2.90901 2.90901C3.33097 2.48705 3.90326 2.25 4.5 2.25H6C6.41421 2.25 6.75 2.58579 6.75 3C6.75 3.41421 6.41421 3.75 6 3.75H4.5Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 2.25C5.25 1.42157 5.92157 0.75 6.75 0.75H11.25C12.0784 0.75 12.75 1.42157 12.75 2.25V3.75C12.75 4.57843 12.0784 5.25 11.25 5.25H6.75C5.92157 5.25 5.25 4.57843 5.25 3.75V2.25ZM11.25 2.25H6.75V3.75H11.25V2.25Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1337 11.8667C18.3452 12.0782 18.3452 12.4212 18.1337 12.6327L11.6337 19.1327C11.4221 19.3442 11.0792 19.3442 10.8676 19.1327C10.6561 18.9212 10.6561 18.5782 10.8676 18.3667L17.3676 11.8667C17.5792 11.6551 17.9221 11.6551 18.1337 11.8667Z",
    fill: "#D13333",
    stroke: "#D13333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8676 11.8667C11.0792 11.6551 11.4221 11.6551 11.6337 11.8667L18.1337 18.3667C18.3452 18.5782 18.3452 18.9212 18.1337 19.1327C17.9221 19.3442 17.5792 19.3442 17.3676 19.1327L10.8676 12.6327C10.6561 12.4212 10.6561 12.0782 10.8676 11.8667Z",
    fill: "#D13333",
    stroke: "#D13333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnHomecomingNo);
export default __webpack_public_path__ + "static/media/wn-homecoming-no.16b6d75af2aafbceb13b4426d79d651a.svg";
export { ForwardRef as ReactComponent };